export default "__VITE_ASSET__B5_J5kRk__"